import React from 'react';

import BlockSelection from './blockSelection';
import CTAButton from './ctaButton';

const MultiBlockSelection = ({ ...props }) => {

    const elements = props.rooms.map((room, i)=>{
        return (
            <div 
                className="flex w-full lg:w-1/2"
                key={i}
            >
                <BlockSelection 
                    title={room.title}
                    description={room.description}
                    buttonText={props.buttonText || room.buttonText}
                    onButtonClick={()=>{
                        console.log("ROOM", room.stream); 
                        return props.onButtonClick(room);
                    }}
                />
            </div>
        )
    });
    
    return (
        <div className="flex w-full space-x-4">
            {elements}
        </div>
    );
};
export default MultiBlockSelection;